import { render, staticRenderFns } from "./RulesetSkeleton.vue?vue&type=template&id=6e7b806f&"
import script from "./RulesetSkeleton.vue?vue&type=script&lang=js&"
export * from "./RulesetSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports